import { render } from "./AdminGrid.vue?vue&type=template&id=caf4d008"
import script from "./AdminGrid.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./AdminGrid.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script